import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {
  faCheckCircle,
  faTimesCircle,
  faStar,
} from "@fortawesome/free-regular-svg-icons";
import FileInput from "./fileInput";
import DropArea from "./dropArea";

const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 7px;
  width: ${({ width }) => width};
  position: relative;

  ${({ areaCss }) => areaCss}
`;

const StyledLabel = styled.label`
  color: ${({ theme }) => theme.fontColor};
  font-family: ${({ theme }) => theme.font.youshe};
  font-size: ${({ theme }) => theme.fontSize.slarge};
  opacity: 0.8;
`;

const StyledInput = styled.input.attrs({
  autoComplete: "off",
})`
  appearance: none;
  /* opacity: ${({ type }) => (type === "file" ? "0" : "1")}; */
  display: block;
  width: ${({ inputWidth }) => inputWidth};
  border: 0;
  outline: none;
  line-height: 1;
  border-bottom: 1px solid ${({ theme }) => theme.black};
  color: ${({ theme }) => theme.black};
  font-size: ${({ theme, inputFontSize, type }) =>
    type === "file" ? theme.fontSize.lsmall : inputFontSize};
  transition: 0.4s;
  &::placeholder {
    text-transform: uppercase;
    color: ${({ theme }) => theme.weakGray};
  }
`;

const statusTypes = (theme) => {
  return {
    0: {
      name: "no",
      icon: faTimesCircle,
      color: theme?.weakRed,
    },
    1: {
      name: "ok",
      icon: faCheckCircle,
      color: theme?.green,
    },
    2: {
      name: "wait",
      icon: faStar,
      color: theme?.infoBlue,
    },
  };
};

const StyledIcon = styled(FontAwesomeIcon)``;

const StyledStatus = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  column-gap: 7px;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme, type }) => statusTypes(theme)[type].color};
`;

const InputGroup = ({
  width,
  inputWidth = "100%",
  label,
  type,
  name,
  value,
  title,
  onChange,
  placeholder,
  inputFontSize = "16px",
  disabled = false,
  status,
  ...rest
}) => {
  const isFile = useMemo(() => {
    return type === "file";
  }, [type]);

  const [fileName, setFileName] = useState([]);

  return (
    <DropArea
      enable={isFile}
      onDropFile={(files) => {
        if (onChange && onChange(files) == "invalid file") {
          return;
        }
        const fileNames = Array.from(files).map(file => file.name);
        setFileName(fileNames);
      }}
    >
      {({ dropAreaRef, areaCss }) => {
        return (
          <StyledInputGroup
            ref={dropAreaRef}
            width={width}
            areaCss={areaCss}
            {...rest}
          >
            <StyledLabel title={title} htmlFor={name}>
              {label}
            </StyledLabel>
            {isFile ? (
              <FileInput
                v={fileName}
                setV={setFileName}
                onChange={
                  disabled ? () => {} : (e) => onChange(e.currentTarget.files)
                }
              />
            ) : (
              <StyledInput
                inputWidth={inputWidth}
                name={name}
                type={type}
                placeholder={placeholder}
                value={value}
                inputFontSize={inputFontSize}
                onChange={
                  disabled
                    ? () => {}
                    : (e) => {
                        onChange(e.currentTarget.name, e.currentTarget.value);
                      }
                }
              />
            )}

            {status && (
              <StyledStatus type={status.type}>
                <StyledIcon
                  icon={statusTypes()[status.type].icon}
                  spin={status.type === 2}
                />
                {status.message}
              </StyledStatus>
            )}
          </StyledInputGroup>
        );
      }}
    </DropArea>
  );
};

export default InputGroup;
